import data from './bar.data'
import label from './bar.label'
import itemStyle from './bar.itemStyle'
import backgroundStyle from './bar.backgroundStyle'
import tooltip from './bar.tooltip'

export default {
  name: "bar",
  nickname: "柱状图",
  desc: "bar",
  type: "object",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc:
        '系列名称，用于<a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip">tooltip</a>的显示，<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend">legend</a> 的图例筛选，在 <code class="codespan">setOption</code> 更新数据和配置项时用于指定对应的系列。',
    },
    barWidth: {
      name: "barWidth",
      nickname: "柱条宽度",
      desc: "柱条的宽度，不设时自适应。",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
    data,
    label,
    itemStyle,
    backgroundStyle,
    stack: {
      name: "stack",
      nickname: "数据堆叠",
      desc:
        '数据堆叠，同个类目轴上系列配置相同的<code class="codespan">stack</code>值可以堆叠放置。',
    },
    tooltip,
    type: {
      name: "type",
      nickname: "类型",
      desc: "type",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
  },
}
